// extracted by mini-css-extract-plugin
module.exports = {"tag":"Complain_tag__1VVB8","tagActive":"Complain_tagActive__0vpgM","inputArea":"Complain_inputArea__UhVvV"};